import tmhRequest from '@/config/tmhRequest'

export default {

    searchSignInfoCount: function (data) {
        return tmhRequest({
            url: '/employee/tmh/signinfo/searchsigninfocount',
            method: 'post',
            data: data,
        })
    },

    searchSignInfoByPage: function (data) {
        return tmhRequest({
            url: '/employee/tmh/signinfo/searchsigninfobypage',
            method: 'post',
            data: data,
        })
    },

    addSignInfo: function (data) {
        return tmhRequest({
            url: '/employee/tmh/signinfo/addsigninfo',
            method: 'post',
            params: data,
        })
    },

    multiDeleteSignInfo: function (data) {
        return tmhRequest({
            url: '/employee/tmh/signinfo/multideletesigninfo',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/employee/signinfo.js